/*********************************************************
 *                  Admin gestion des logs des campagnes de comptages
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminLogCampagnsCtrl",["$scope", "toastr", "Utils", "AdminLogCampagnsService", "listApplicationsStatistiques", function ($scope, toastr, Utils, AdminLogCampagnsService, listApplicationsStatistiques) {

		$scope.data = {
			checkbox: false,
			date: {
				first: "",
				last: ""
			},
			filesToDelete: {},
			logs: [],
			applications: listApplicationsStatistiques.data,
			applicationSelected: ""
		};


		/**
     * Sélectionner une application
     * @param nameAppli
     */
		$scope.applicationSelected = function (nameAppli) {
			if (nameAppli) {
				AdminLogCampagnsService.getLogsCampagns(nameAppli)
					.then((response) => {
						const data = response.data;
						$scope.data.checkbox = false;
						$scope.data.filesToDelete = {};

						//Charger toute la liste avant d'enlever les élèments qui ne colle pas
						$scope.data.logs = data;

						//Affiner avec les dates
						if (($scope.data.date.first != "") && ($scope.data.date.last != "")) {
							for (var i = 0; i < $scope.data.logs.length; i++) {
								for (var j = 0; j < $scope.data.logs[i].files.length; j++) {
									var aFileInfo = $scope.data.logs[i].files[j].split("_");
									var date = new Date(Utils.stringToDate(aFileInfo[2], "dd-MM-yyyy", "-").toString());
									if ((new Date($scope.data.date.first).getTime() <= date.getTime()) && (date.getTime() >= new Date($scope.data.date.last).getTime())) {
										$scope.data.logs[i].files.splice(j, 1);
										j--; //Pour prendre en compte le décalage
									}
								}
							}
						}
					})
					.catch((response) => {
						const data = response.data;
						let errorMessage = "Problème lors de la récupération des logs";
						if (data !== undefined && data.message) {
							errorMessage += " " + data.message;
						}
						toastr.error(errorMessage, "Erreur");
					});
			}
		};

		$scope.deleteFiles = function () {
			var filesDelete = Utils.keepTabValueTrueOnlyToStringWithComma($scope.data.filesToDelete);
			AdminLogCampagnsService.deleteFiles(filesDelete, $scope.data.applicationSelected)
				.then(() => {
					$scope.applicationSelected($scope.data.applicationSelected);
					toastr.success("Les élèments ont été supprimé", "Mise à jour effectuée");
				})
				.catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la récupération du fichier";
					if (data !== undefined && data.message) {
						errorMessage += " " + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		/**
     * Changer etat checkbox
     */
		$scope.changeStateCheckbox = function () {
			if ($scope.data.checkbox) {
				$scope.data.checkbox = false;
				$scope.data.filesToDelete = {};
			} else {
				$scope.data.checkbox = true;
				$scope.addAllFileToDelete();
			}
		};

		$scope.addAllFileToDelete = function () {
			for (var i = 0; i < $scope.data.logs.length; i++) {
				for (var j = 0; j < $scope.data.logs[i].files.length; j++) {
					$scope.definirFileToDelete($scope.data.logs[i].files[j], true);
				}
			}
		};

		$scope.changeStateCheckboxFile = function (file) {
			if (!$scope.data.filesToDelete[file]) {
				$scope.definirFileToDelete(file, true);
			} else {
				$scope.definirFileToDelete(file, false);
			}
		};

		$scope.definirFileToDelete = function (file, status) {
			$scope.data.filesToDelete[file] = status;
		};

		/**
     * Récupérer un fichier
     * @param applicationName
     * @param schemaName
     * @param fileName
     */
		$scope.downloadFile = function (applicationName, schemaName, fileName) {
			AdminLogCampagnsService.getFile(applicationName, schemaName, fileName)
				.then((response) => {
					var blob = new Blob([JSON.stringify(response.data)], {type: "octet/stream"});
					var a = document.createElement("a");
					a.href = (window.URL || window.webkitURL).createObjectURL(blob);
					a.target = "_blank";
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
				})
				.catch(function (data) {
					var errorMessage = "Problème lors de la récupération du fichier";
					if (data !== undefined && data.message) {
						errorMessage += " " + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

	}])
;

